/* ══════════════════════════════════════════════════════════
   AIRSPIN — LANDING PAGE
   Fichier : assets/airspin-landing.js
   À charger en defer : chargement des visuels, retournement
   des cartes, vidéo à lecture unique, avis, FAQ, barre fixe.
   ══════════════════════════════════════════════════════════ */

(function () {
  var btn = document.getElementById('asListen');
  var audio = document.getElementById('asAudio');
  if (!btn || !audio) return;
  var lab = btn.querySelector('.lab');
  function set(on) {
    btn.classList.toggle('on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    lab.textContent = on ? 'Arrêter' : 'Écouter';
  }
  btn.addEventListener('click', function () {
    if (audio.paused) { audio.currentTime = 0; audio.play().then(function () { set(true); }).catch(function () { set(false); }); }
    else { audio.pause(); set(false); }
  });
  audio.addEventListener('ended', function () { set(false); });
})();

(function () {
  var SRC = {
    flow:      "https://cdn.shopify.com/s/files/1/0941/0189/7591/files/WEB_CHOIX_4.png?v=1786957533",
    power:     "https://cdn.shopify.com/s/files/1/0941/0189/7591/files/WEB_CHOIX_5.png?v=1786957556",
    flowback:  "https://cdn.shopify.com/s/files/1/0941/0189/7591/files/23695EA7-1BC8-4F97-B17C-A2C4A147BA56.png?v=1785769476",
    powerback: "https://cdn.shopify.com/s/files/1/0941/0189/7591/files/01EB7C36-36D5-4B8A-B286-724C27A00E03.png?v=1785769476"
  };
  document.querySelectorAll('[data-src]').forEach(function (i) { i.src = SRC[i.dataset.src]; });

  function setFlip(card, on) {
    card.classList.toggle('is-flipped', on);
    var t = card.querySelector('[data-flip]');
    if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
    card.querySelectorAll('.face--back a, .face--back button').forEach(function (el) { el.tabIndex = on ? 0 : -1; });
    card.querySelectorAll('.face--front button, .face--front a').forEach(function (el) { el.tabIndex = on ? -1 : 0; });
  }
  document.querySelectorAll('.gammes .card').forEach(function (c) { setFlip(c, false); });

  document.addEventListener('click', function (e) {
    var f = e.target.closest('[data-flip]');
    if (f) { setFlip(f.closest('.card'), true); return; }
    var u = e.target.closest('[data-unflip]');
    if (u) { setFlip(u.closest('.card'), false); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.card.is-flipped').forEach(function (c) {
      setFlip(c, false);
      var t = c.querySelector('[data-flip]'); if (t) t.focus();
    });
  });
})();

(function () {
  var v = document.getElementById('spVideo');
  if (!v) return;

  var termine = false;
  v.addEventListener('ended', function () {
    termine = true;      // la dernière image reste affichée, aucune relance
    v.pause();
  });

  // Mouvement réduit : aucune lecture automatique, commandes natives
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) { v.controls = true; return; }

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (termine) { io.unobserve(v); return; }
        if (e.isIntersecting) { v.play().catch(function () { v.controls = true; }); }
        else { v.pause(); }
      });
    }, { threshold: 0.65 });
    io.observe(v);
  } else {
    v.play().catch(function () { v.controls = true; });
  }
})();

(function () {
  var AVIS = [
    { p: "https://cdn.shopify.com/s/files/1/0941/0189/7591/files/1_0ff9c741-ee6a-44a8-9afb-77351df57831.png?v=1768506355",
      t: "Le sifflet ne ment pas. J\u2019ai corrig\u00e9 mon poignet en deux s\u00e9ances.", n: "Thomas L.", c: "Class\u00e9 15/4" },
    { p: "https://cdn.shopify.com/s/files/1/0941/0189/7591/files/2_398c0cc4-837c-40f9-bd41-4516e98de196.png?v=1768506366",
      t: "Il ne se d\u00e9clenche que quand j\u2019acc\u00e9l\u00e8re vraiment. Le reste du temps, silence.", n: "Jordan M.", c: "Class\u00e9 30/1" },
    { p: "https://cdn.shopify.com/s/files/1/0941/0189/7591/files/3_7f07b656-9786-4f7e-abca-590df62fe2ca.png?v=1768506410",
      t: "Mon coach n\u2019a plus besoin de me le dire. Je l\u2019entends moi-m\u00eame.", n: "Camille R.", c: "Class\u00e9e 15/5" }
  ];
  var STAR = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 2.6l2.9 5.9 6.5.9-4.7 4.6 1.1 6.5-5.8-3-5.8 3 1.1-6.5L2.6 9.4l6.5-.9z"/></svg>';
  document.getElementById('track').innerHTML = AVIS.map(function (a) {
    return '<article class="avcard">' +
      '<img src="' + a.p + '" alt="' + a.n + '" loading="lazy" decoding="async">' +
      '<div class="band">' +
        '<span class="stars" role="img" aria-label="5 \u00e9toiles sur 5">' + STAR.repeat(5) + '</span>' +
        '<p class="quote">\u00ab ' + a.t + ' \u00bb</p>' +
        '<p class="who">' + a.n + ' <span>\u2014 ' + a.c + '</span></p>' +
      '</div></article>';
  }).join('');
})();

(function () {
  var items = document.querySelectorAll('.fq__item');
  items.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      items.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });
})();

(function () {
  var bar = document.getElementById('sbar');
  var gam = document.querySelector('.gammes');
  var fin = document.querySelector('.cta');
  if (!bar || !gam) return;

  var actif = false, demande = false;
  function maj() {
    demande = false;
    var passe = gam.getBoundingClientRect().top < -40;
    var finVisible = fin && fin.getBoundingClientRect().top < innerHeight;
    var on = passe && !finVisible;
    if (on !== actif) {
      actif = on;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    }
  }
  function tick() { if (!demande) { demande = true; requestAnimationFrame(maj); } }
  addEventListener('scroll', tick, { passive: true });
  addEventListener('resize', tick, { passive: true });
  maj();
})();